import { render, staticRenderFns } from "./field-props.vue?vue&type=template&id=6cdfe745&"
import script from "./field-props.vue?vue&type=script&lang=js&"
export * from "./field-props.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports